module.exports = __webpack_public_path__ + "static/media/service-hogar.5ffb4e6c.png";